import React from 'react';
import PropTypes from 'prop-types';
import { MainSide, Header, LineContent } from './styles';
import CollaboratorsSkeleton from './CollaboratorsSkeleton';
import ContactDataSkeleton from './ContactDataSkeleton';

const Skeleton = ({ device, currentTab }) => {
  /**
   * La función valida en que sección se encuentra para devolver el skeleton correspondiente.
   * @returns - Retorna el componente a renderizar.
   */
  const getCurrentTabSekeleton = () => {
    if (currentTab === 'contactsData') return <ContactDataSkeleton device={device} />;
    return <CollaboratorsSkeleton device={device} />;
  };

  return (
    <MainSide>
      {device === 'desktop' && (
        <Header>
          <section>
            <LineContent width='356px' marginTop='3px' marginBottom='21px' />
            <LineContent width='331px' />
          </section>
        </Header>
      )}
      {device !== 'desktop' && (
        <Header>
          <section>
            <LineContent width={device === 'mobile' ? '312px' : '605px'} marginTop='12px' marginBottom='8px' />
            <LineContent width='155px' />
          </section>
        </Header>
      )}
      {getCurrentTabSekeleton()}
    </MainSide>
  );
};

Skeleton.propTypes = {
  device: PropTypes.string.isRequired,
  currentTab: PropTypes.string.isRequired
};

export default Skeleton;
